.root {
  display: inline-block;

  .icon {
    cursor: pointer;
  }
}